import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Pagetitle from 'components/pageTitle'
import * as Service from 'components/service/allItem'
import Footer from 'components/footer'
import Cta from 'components/cta'
import Seo from 'components/seo'

import { pagemeta, servicesHomeData } from 'data/services'

export default function services() {
  return (
    <>
      <Seo
        title="Nos services"
        description="Découvrez nos services pour développer votre présence digitale et vous amenez de nombreux clients et abonnés sur les réseaux sociaux!"
        canonical="/services"
        schema={({ fullTitle, description, url }) => ({
          '@context': 'https://schema.org',
          '@type': 'OfferCatalog',
          name: fullTitle,
          description: description,
          mainEntityOfPage: url,
          itemListElement: servicesHomeData.map((thisService) => ({
            '@type': 'ListItem',
            name: thisService.name,
            description: thisService.descriptionServicesPage,
            url: `${process.env.NEXT_PUBLIC_BASEPATH}/services/${thisService.slug}`
          }))
        })}
      />
      <div className="overflow-hidden">
        <Navbar />
        <main className="relative mt-12 md:mt-24">
          <Layout>
            <Pagetitle>Services</Pagetitle>

            <div className="mt-8">
              <Textlayout>
                <div className="space-y-4 text-justify text-lg leading-tight">{pagemeta.intro}</div>
              </Textlayout>
            </div>
          </Layout>

          <div className="mt-12">
            {servicesHomeData.map((thisService, index) => {
              const Servicecomponent = index % 2 === 0 ? Service.r : Service.l

              return (
                <section key={thisService.id} id={thisService.slug}>
                  <Servicecomponent
                    title={thisService.name}
                    image={thisService.image.image}
                    imageAlt={thisService.image.alt}
                    bullets={thisService.bullets}
                    slug={thisService.slug}>
                    {thisService.descriptionServicesPage}
                  </Servicecomponent>
                </section>
              )
            })}
          </div>

          <Layout>
            <Cta href="/contact" className="mt-12 md:mt-24">
              Demander un devis
            </Cta>
          </Layout>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
    </>
  )
}
